import _defineProperty from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _regeneratorRuntime from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
var initialState = {
  rca: {
    search: null,
    filters: false,
    offers: [],
    status: 'idle'
  }
};
export var loadRCAOffers = createAsyncThunk('compare/loadRCAOffers', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var response;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return axios({
            method: 'get',
            url: process.env.NEXT_PUBLIC_API + '/api/user/asigurari/rca/oferte',
            params: {
              items: 5,
              page: 1,
              availability: true
            },
            withCredentials: true
          });

        case 2:
          response = _context.sent;
          return _context.abrupt("return", response.data);

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})));
var compareSlice = createSlice({
  name: 'compare',
  initialState: initialState,
  reducers: {
    searchUpdate: function searchUpdate(state, action) {
      var data = action.payload;
      var product = data.product;
      state[product].search = data;
    },
    filterUpdate: function filterUpdate(state, action) {
      var _action$payload = action.payload,
          product = _action$payload.product,
          data = _objectWithoutProperties(_action$payload, ["product"]);

      state[product].filters = data;
    },
    setStatus: function setStatus(state, action) {
      state.status = action.payload;
    }
  },
  extraReducers: _defineProperty({}, loadRCAOffers.fulfilled, function (state, action) {
    var _action$payload2 = action.payload,
        status = _action$payload2.status,
        list = _action$payload2.list;

    if (status == 'success') {
      state.rca.offers = list;
    }

    state.rca.status = 'load';
  })
});
var _compareSlice$actions = compareSlice.actions,
    searchUpdate = _compareSlice$actions.searchUpdate,
    filterUpdate = _compareSlice$actions.filterUpdate,
    setStatus = _compareSlice$actions.setStatus;
export { searchUpdate, filterUpdate, setStatus };
export default compareSlice.reducer;